import { render, staticRenderFns } from "./text-mask.vue?vue&type=template&id=16f669ca"
import script from "./text-mask.vue?vue&type=script&lang=js"
export * from "./text-mask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports